module.exports = __webpack_public_path__ + "assets/img/sig_cert_logo.255d8d16.webp";